import React, {useCallback, useState} from 'react'
import {Checkbox} from "@material-ui/core";

const UCCheckbox = ({data, name, rawData}) => {
  const [value, setValue] = useState(data[name] || false)
  const onClick = useCallback(() => {
    setValue(value => {
      if (value) {
        // data[name] = false
        delete data[name]
        return false
      }
      data[name] = rawData
      return rawData
    })
  }, [rawData])

  return (
    <div onClick={onClick} style={{width: 40, display: "inline-block"}}>
      <Checkbox
        checked={!!value}
      />
    </div>
  )
}

export default UCCheckbox